'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view')
/*
{
  id: 'client',
  domain: 'client',
  collection: App.globalChannel.request('client:entities', {query: {fields: 'name'}}),
  collectionMap: {label: 'name', value: '_id'}
}
 */

// var ListView = require('./list-view.js')

// var ListController = Marionette.Object.extend({
//   initialize: function (options) {
//     this.container = options.container

//     var clientsListView = new ListView({collection: App.entities.clients})
//     // view events
//     clientsListView.on('childview:client:edit', _.bind(this.onEdit, this))
//     clientsListView.on('childview:client:manage', _.bind(this.onManage, this))
//     clientsListView.on('client:add', _.bind(this.onAdd, this))
//     //
//     this.container.show(clientsListView)
//   },
//   onManage: function (args) {
//     this.triggerMethod('show:client', args.model)
//   },
//   onEdit: function (args) {
//   },
//   onAdd: function (args) {
//   }
// })

var DevicesFilter = Marionette.Object.extend({
  initialize: function (options) {
    var self = this

    // filter collection
    var FilterModel = Backbone.Model.extend({})
    var FilterCollection = Backbone.Collection.extend({ model: FilterModel })
    self.filterCollection = new FilterCollection()

    self.filterId = 0

    // var layout = self.getFiltersLayout(self.filterCollection)
    self.layout = self.getLayout(options)
    self.layout.on('render', function () {
      self.filterAddRegion()
      self.filtersRegion()
      self.loadCache()
    })

    if (self.options.filterCache['query']) {
      // added setTimeout becuase otherwise the devices list wasn't loaded yet
      setTimeout(function () {
        self.trigger('queryUpdate', self.options.filterCache['query'])
      }, 0)
    } else {
      setTimeout(function () {
        self.trigger('queryUpdate', {})
      }, 0)
    }

    self.options.region.show(self.layout)
  },
  loadCache: function () {
    var self = this

    if (!self.options.filterCache.filters) return false

    // var self = this
    _.forEach(self.options.filterCache.filters, function (filterValues, filterName) {
      self.onAddFilter(filterName, {
        popupVisible: false,
        selectedValues: filterValues
      })
    })
  },
  filterAddRegion: function () {
    var self = this
    // holds all the available filters
    var FilterOptionModel = Backbone.Model.extend({})
    var FilterOptionsCollection = Backbone.Collection.extend({ model: FilterOptionModel })
    self.filterOptionsCollection = new FilterOptionsCollection()
    _.forEach(self.options.filters, function (filter) {
      // check if this filter is permitted
      if (!App.session.user.hasRole(filter.role)) return
      self.filterOptionsCollection.add({
        id: filter.id,
        label: filter.label
      })
    })

    var filterAddRegion = self.getFilterAddLayout(self.filterOptionsCollection)
    filterAddRegion.on('childview:filter:add', function (args) {
      self.onAddFilter(args.model.get('id'))
      filterAddRegion.hidePopupEl()
    })
    // regionLayout.on('childview:filter:apply', _.bind(self.onFilterInteraction, self))
    filterAddRegion.on('render', function () {})
    self.layout.showChildView('filterAddRegion', filterAddRegion)
  },
  filtersRegion: function () {
    var self = this
    var regionLayout = self.getFiltersLayout(self.filterCollection)
    regionLayout.on('childview:filter:remove', _.bind(self.onFilterRemove, self))
    regionLayout.on('childview:filter:apply', _.bind(self.onFilterInteraction, self))

    self.layout.showChildView('filtersRegion', regionLayout)
  },
  onAddFilter: function (id, options) {
    var self = this

    // if the filter is already added to the filterlist
    if (self.filterCollection.get(id)) {
      let filter = self.filterCollection.get(id)
      filter.set('popupVisible', true)
      return false
    }

    var filter = _.find(self.options.filters, { 'id': id})
    if (!filter) return false
    var filterObject = {
      id: filter.id,
      type: filter.type,
      name: filter.name,
      domain: filter.domain,
      lingualSubject: filter.lingualSubject,
      prependedText: filter.prependedText,
      popupVisible: true,
      fieldLabel: 'choose...',
      selectedValues: false,
      value: filter.value
    }

    filterObject = _.extend(filterObject, options)

    switch (filter.type) {
      case 'select':
      case 'multi_select':
        var proxiedCollection = self.proxyOptionsCollection(filter.collection, filter.collectionMap, filterObject.selectedValues)
        filterObject.collection = proxiedCollection
        break
      case 'text':
        filterObject.selectedValues = filterObject.selectedValues
        break
    }

    // attach listeners
    self.filterCollection.add(filterObject)
    self.filterId++
  },
  onFilterRemove: function (ev) {
    var self = this
    self.filterCollection.remove(ev.model.get('id'))
    self.onFilterInteraction()
  },
  onFilterInteraction: function () {
    var self = this
    // cache the filters
    self.cacheFilters()
    self.updateQuery()
  },
  cacheFilters: function () {
    var self = this

    // store the query in the cache
    self.options.filterCache['query'] = self.generateQueryObject()

    self.options.filterCache['filters'] = {}
    // store the filter setup in the cache
    self.filterCollection.each(function (filterModel) {
      var value = self.getFilterValue(filterModel)
      self.options.filterCache['filters'][filterModel.attributes.id] = value
    })
  },
  getFilterValue: function (filterModel) {
    var self = this
    var value = false
    switch (filterModel.get('type')) {
      case 'select':
      case 'multi_select':
        value = filterModel.attributes.collection.filter(function (model) {
          return model.attributes.selected
        }).map(function (model) {
          return model.get('value')
        })
        break
      case 'location':
        var value = filterModel.get('value')
        var location = value.location
        var radius = value.radius
        value = location[0] + ',' + location[1] + ',' + radius
        break
      case 'text':
        value = filterModel.get('value')
        break
    }

    return value
  },
  /**
   * Generate query and trigger query update event
   */
  updateQuery: function () {
    var self = this
    var queryObject = self.generateQueryObject()
    self.trigger('queryUpdate', queryObject)
  },
  /**
   * Generate query object based on the active filters
   */
  generateQueryObject: function () {
    var self = this
    var queryObject = {}

    self.filterCollection.each(function (filterModel) {
      var value = self.getFilterValue(filterModel)

      if (value) {
        queryObject[filterModel.get('id')] = value
      }
    })

    return queryObject
  },
  /**
   * converts an existing collection into a collection suitable for the filter
   */
  proxyOptionsCollection: function (originalColl, keyMap, selectedValues) {
    var FilterOption = Backbone.Model.extend({})
    var FilterOptionsCollection = Backbone.Collection.extend({
      model: FilterOption
    })
    var filterOptionsCollection = new FilterOptionsCollection()

    var setFilterCollection = function () {
      _.forEach(originalColl.models, function (model) {
        var filter = {
          'label': model.get(keyMap.label),
          'value': model.get(keyMap.value),
          'selected': false
        }

        // select the selected values
        if (selectedValues) {
          if (selectedValues.indexOf(filter.value) > -1) {
            filter.selected = true
          }
        }

        filterOptionsCollection.add(filter)
      })
    }

    originalColl.on('reset', function () {
      filterOptionsCollection.reset()
      setFilterCollection()
    })

    setFilterCollection()

    return filterOptionsCollection
  },
  // -- Layouts --
  getFilterAddLayout: function (filterOptions) {
    return new View.FilterAddLayout({collection: filterOptions})
  },
  getFiltersLayout: function (filters) {
    return new View.FiltersLayout({collection: filters})
  },
  getLayout: function (options) {
    return new View.Layout({filterOptions: options})
  }
})

module.exports = DevicesFilter



// WEBPACK FOOTER //
// ./js/components/devices-filter/index.js